import Vue from 'vue';
import VueRouter from 'vue-router';
import { i18n } from '../plugins/i18n.js';
import { helpers } from '../helper/portal_config';
import { landing_routes } from '../helper/landing_routes';
import { loadLanguageAsync } from '@/plugins/i18n.js';
import { setCookie, getCookie } from "../helper/cookies";

Vue.config.silent = true;

//pin flow
const NotFound = () => import('@/views/NotFound.vue');
const LegalsTerms = () => import('@/views/legals/terms.vue');
const LegalsPrivacy = () => import('@/views/legals/privacy.vue');
const LegalsCookiesPolicy = () => import('@/views/legals/cookies_policy.vue');
const LegalsContact = () => import('@/views/legals/contact.vue');
const LegalsCancel = () => import('@/views/legals/cancel.vue');

Vue.use(VueRouter);

const routes = [
    {
        path: '/error',
        component: NotFound,
    },
    {
        path: '/terms',
        component: LegalsTerms,
    },
    {
        path: '/privacy',
        component: LegalsPrivacy,
    },
    {
        path: '/cookies-policy',
        component: LegalsCookiesPolicy,
    },
    {
        path: '/contact',
        component: LegalsContact,
    },
    {
        path: '/cancel',
        component: LegalsCancel,
    }
].concat(landing_routes);

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({ x: 0, y: 0 });
            }, 400);
        });
    },
});

router.beforeEach((to, from, next) => {
    const $q = to.query;
    let cookie_lang = getCookie("landing_lang");
    let param_lang = (($q.hasOwnProperty("lang")) ? $q["lang"] : "");
    let navig_lang_two_letters = navigator.language.slice(0,2);
    let current_lang = helpers.active_language

    if (helpers.available_languages.includes(param_lang)) {
        current_lang = param_lang;
    } else if (helpers.available_languages.includes(cookie_lang)) {
        current_lang = cookie_lang; 
    } else if (helpers.available_languages.includes(navig_lang_two_letters)) {
        current_lang = navig_lang_two_letters;
    }

    i18n.fallbackLocale = helpers.active_language;
    loadLanguageAsync(current_lang).then(() => next())
});

export default router;